import React, { useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level3LayoutProps from '../types/Level3LayoutProps'
import Page from '../types/Page'
import SearchResults from '../types/SearchResults'
import parse from 'html-react-parser'

interface Response {
  data: Array<Page>,
  meta: {
    pagination?: {
      total: number,
      count: number,
      per_page: number,
      current_page: number,
      total_pages: number,
      links?: {}
    }
  }
}

interface ResultsState {
  entries: Response
}

const menuExceptions = [
  'digital-resources',
  'music',
  'movies-tv',
  'newspapers-magazines'
]

export default ({ level2active }: Level3LayoutProps) => {
  const [ state, setState ] = useState<ResultsState>({ entries: { data: [], meta: {} }  })
  const term = window.location.search.substring(1).replace(/\+/g, ' ')
  let searchResults: SearchResults = { menus: [], pages: [], events: [], topics: [], external: [] }

  const cache = Math.floor((new Date()).getTime() / (1000 * 60 * 15)); // Refetch api every 15 mins
  useEffect(() => {
    fetch('/search.json?' + cache).then(res => res.json()).then(res => {
      setState({ entries: res })
    })
  }, [])

  if (state.entries.data && state.entries.data.length && term !== '') {
    const curatedResults: Array<number> = state.entries.data.filter((p: Page) => p.type === 'curatedSearchResults' && 
      p.synonyms!.findIndex(s => s.toLowerCase().includes(term.toLowerCase())) >= 0).map((p: Page) => p.results).flat()
    
    const results: Array<Page> = state.entries.data.filter((p: Page) => p.type !== "curatedSearchResults" && 
      p.title.toLowerCase().includes(term.toLowerCase()))

    const pages: Array<Page> = results.filter(r => r.type === 'pages' && !curatedResults.includes(r.id))

    searchResults = {
      menus: results.filter(r => r.type === 'menuLevel2' && menuExceptions.includes(r.slug) && !curatedResults.includes(r.id)),
      pages: state.entries.data.filter(e => curatedResults.includes(e.id)).concat(pages),
      events: results.filter(r => r.type === 'events' && !curatedResults.includes(r.id)),
      topics: results.filter(r => r.type === 'topics' && !curatedResults.includes(r.id)),
      external: results.filter(r => r.type === 'externalSearchResults' && !curatedResults.includes(r.id)),
    }
  }

  if (term === '') {
    return null
  }

  const noResults = searchResults!.topics.length === 0 && searchResults!.pages.length === 0 && searchResults!.events.length === 0 && searchResults!.external.length === 0 && searchResults!.menus.length === 0

  return (
    <div className="level-3 search-results" id={level2active.slug}>
      <div className={`details${noResults ? ' no-results' : ''}`}>
        {searchResults!.menus.length > 0 && (<h2 className="result-group">Menu Items</h2>)}
        {searchResults!.menus.map(p => {
          return (
            <a href={p.url} className="result-menus result-card" key={p.url}>
              <h2>{p.title}</h2>
            </a>
          )
        })}
        {searchResults!.pages.length > 0 && (<h2 className="result-group">Pages</h2>)}
        {searchResults!.pages.map(p => {
          return (
            <a href={p.url} className="result-pages result-card" key={p.url}>
              <h2>{p.title}</h2>
            </a>
          )
        })}
        {searchResults!.topics.length > 0 && (<h2 className="result-group">Topics</h2>)}
        {searchResults!.topics.map(t => {
          return (
            <a href={t.url} className="result-topics result-card" key={t.url}>
              <h2>{t.title}</h2>
            </a>
          )
        })}
        {searchResults!.events.length > 0 && (<h2 className="result-group">Events</h2>)}
        {searchResults!.events.map(e => {
          return (
            <a href={e.url} className="result-events result-card" key={e.url}>
              <h2>{e.title}</h2>
            </a>
          )
        })}
        {searchResults!.external.length > 0 && (<h2 className="result-group">External Sites</h2>)}
        {searchResults!.external.map(e => {
          return (
            <a href={e.link} className="result-external result-card" key={e.url}>
              <h2>{e.title}</h2>
            </a>
          )
        })}
        {noResults && (
            <h2>No Results Found for "{term}"</h2>
          )
        }
      </div>
      <div className="details">
        <strong className="full-site-search-label">Don't see what you need in quick results? Try a full site search</strong>
        <a href={`/site-search${ term !== null ? '?q=' + term : '' }`} className="button m-secondary">Search Full Site</a>
      </div>
    </div>
  )
}